import { AppInventoryOption } from '@openx/types/targeting/appInventory';
import { ComparisonType } from '@openx/types/targeting/targetingValuesTypes';

export const optionsWithBulkAdd = [AppInventoryOption.APP_BUNDLE_ID, AppInventoryOption.APP_GROUP];

export const comparisonOptions = {
  [AppInventoryOption.APP_BUNDLE_ID]: [ComparisonType.EQUALS, ComparisonType.DOES_NOT_EQUAL],
  [AppInventoryOption.APP_GROUP]: [ComparisonType.EQUALS, ComparisonType.DOES_NOT_EQUAL],
};
